export { default as outputs } from './outputs/dev/amplify_outputs.json';
